<template>
  <CSidebar
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand to="/">
      <CIcon
        class="c-sidebar-brand-full"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 642 134"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      />
    </CSidebarBrand>
    <CRenderFunction flat :contentToRender="$options.nav"/>    
    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import SidebarItems from './SidebarItems'
import nav from "./_nav";

export default {
  name: 'TheSidebar',
  nav,
  created() {
    this.permisos();
  },
  computed: {
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  },
  methods: {
    permisos: function () {
      let array = [];
      array = this.$options.nav;
      
      let permisos = this.$store.getters.get__permissionxrol;
      let rubro = this.$store.getters.get_rubro; // <-- LEEMOS EL RUBRO ACTUAL (GAS o AIRE)
      
      let arr_permiso = [];

      permisos.forEach((element) => {
        arr_permiso.push(element["name"]);
      });

      array.forEach((element) => {
        if (element._children) {
          element._children.forEach((submenu) => {
            
            // ============================
            // LÓGICA INTELIGENTE DE FILTRADO POR RUBRO
            // ============================
            let menuName = (submenu.name || '').toUpperCase();
            let isHiddenByRubro = false;

            if (rubro == 'AIRE') {
               // En AIRE, solo permitimos Inicio, Movimientos, Ventas y Aire Acondicionado
               if (
                   !menuName.includes('AIRE') && 
                   !menuName.includes('MOVIMIENTO') && 
                   !menuName.includes('VENTA') && 
                   submenu.id !== 'mainmnu-index' &&
                   submenu.id !== 'desktop-index'
               ) {
                   isHiddenByRubro = true;
               }
            } else if (rubro == 'GAS') {
               // En GAS, bloqueamos cualquier cosa de AIRE ACONDICIONADO
               if (menuName.includes('AIRE')) {
                   isHiddenByRubro = true;
               }
            }
            // ============================

            if (submenu.items == undefined) {
              arr_permiso.forEach((permiso) => {
                if (permiso == submenu.id) {
                  submenu._name = "CSidebarNavItem";
                }
              });

              if (submenu.id == "desktop-index") {
                submenu._name = "CSidebarNavItem";
              } else if (submenu.id == "mainmnu-index") {
                submenu._name = "CSidebarNavTitle";
              }

              // Si el Rubro lo prohíbe, lo desaparecemos forzosamente
              if (isHiddenByRubro) {
                submenu._name = ""; 
              }

            } else {
              let row = submenu.items.length;
              let data_items = submenu.items;
              let num = 0;
              
              arr_permiso.forEach((permiso) => {
                for (let index = 0; index < row; index++) {
                  if (permiso == data_items[index].id) {
                    data_items[index].style = "display:block";
                  }
                }
              });

              data_items.forEach((dt_item) => {
                // FILTRO DE SUB-MENÚS POR RUBRO
                let subName = (dt_item.name || '').toUpperCase();
                
                if (rubro == 'AIRE') {
                    if (!subName.includes('AIRE') && !subName.includes('MOVIMIENTO') && !subName.includes('VENTA')) {
                        dt_item.style = "display:none";
                    }
                } else if (rubro == 'GAS') {
                    if (subName.includes('AIRE')) {
                        dt_item.style = "display:none";
                    }
                }

                if (dt_item["style"] == "display:none" || dt_item["style"] == undefined) {
                  num++;
                }
              });

              // Si todos los submenús están ocultos, o el Rubro general lo prohíbe, desaparecemos el menú padre
              if (row == num || isHiddenByRubro) {
                submenu._name = "";
              }
            }
          });
        }
      });

      this.$options.nav = array;
    },
  },
}
</script>